import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SelectStyled from '../../Select';
import NxtbnModal from '../../../components/Modal';
import { NXForm, InputField } from "../../../components/common";
import useApi from '../../../api';

interface DiscountChooserProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: any, isCustom: boolean) => void;
}

function DiscountChooser({ isOpen, onClose, onSubmit }: DiscountChooserProps) {
  const [formData, setFormData] = useState<any>({});
  const [isCustom, setIsCustom] = useState(false);
  const [discounts, setDiscounts] = useState<any>({});
  const api = useApi();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSelectChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      promo_code: selectedOption
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData, isCustom);
  };

  const handleOptionChange = (option: string) => {
    setIsCustom(option === 'custom');
  };

  useEffect(() => {
    api.getPromocodes().then((response: any) => {
      setDiscounts(response.results.map((discount: any) => ({
        value: discount.code,
        label: discount.code + ` - ${discount.code_type === 'PERCENTAGE' ? discount.value + '%' : '$' + discount.value} ${discount.total_specific_customers ? "- Specific Customer Only": ''} ${discount.total_applicable_products ? "- Specific Product Only": ''}`
      })));

        }, (error) => {
      toast.error("Failed to fetch promocode details")
    })

  }, []);

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <NXForm
        onSubmit={handleSubmit}
        className="p-6"
        title="Discount or Promo Code"
        nonFieldError={{}}
      >
        <div className="mb-6">
          <label className="block font-medium text-gray-700">Discount Rates</label>
          <div className="mt-3">
            <div className="flex items-center">
              <InputField
                type="radio"
                id="shipping_method"
                name="shippingOption"
                value="rate"
                checked={!isCustom}
                onChange={() => handleOptionChange('rate')}
                className="mr-2"
              />
              <label htmlFor="shipping_method" className="text-sm">Discount rates</label>
            </div>
            <small>Select eligible discount rates based on your discount settings</small>

            {!isCustom && (
              <div className="mt-3">
                <SelectStyled
                  options={discounts}
                  onChange={handleSelectChange}
                  className="mt-2"
                  menuPortalTarget={document.body}
                  customStyles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
            )}

            <div className="flex items-center mt-4">
              <InputField
                type="radio"
                id="custom"
                name="shippingOption"
                value="custom"
                checked={isCustom}
                onChange={() => handleOptionChange('custom')}
                className="mr-2"
              />
              <label htmlFor="custom" className="text-sm">Custom</label>
            </div>

            {isCustom && (
              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Custom Shipping Name
                  </label>
                  <InputField
                    name="name"
                    placeholder="E.g. Free shipping"
                    value={formData.name || ''}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="price" className="block text-sm font-medium text-gray-700">
                    Custom Shipping Price
                  </label>
                  <InputField
                    name="price"
                    placeholder="$ 0.00"
                    value={formData.price || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Apply
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
}

export default DiscountChooser;
